import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
//UI

import { authSelector } from '@/stores/auth/authSlice'

//API

import OfferForm from '../components/OfferForm'
import OfferIdleCheckingProvider from '../components/OfferForm/OfferIdleCheckingProvider'
import OfferWebSocketProvider from '../components/OfferForm/OfferWebSocketProvider'
import useOffer from '../hooks/useOffer'
import { setOffer, setOfferRole } from '../slices/offerDetail.slice'
import { LoadingSection } from '@/components/Elements'

//4+5 for uat,

const EditOffer = () => {
  const { id } = useParams()

  //Local State
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { user } = useSelector(authSelector)
  const { useFetchOffer } = useOffer()
  const { data: offer, error, isLoading, isError } = useFetchOffer(id)

  useEffect(() => {
    if (offer && user) {
      dispatch(setOfferRole(user, offer))
      dispatch(setOffer(offer))
    }
  }, [user, offer, dispatch])

  if (isError) {
    return <div>{error.message}</div>
  }

  if (isLoading) {
    return <LoadingSection />
  }

  return (
    <>
      <OfferWebSocketProvider offerId={id}>
        <OfferIdleCheckingProvider>
          <OfferForm offer={offer} />
        </OfferIdleCheckingProvider>
      </OfferWebSocketProvider>
    </>
  )
}

export default EditOffer
